import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Page from '@glowforge/gf-styled/src/components/contentful-views/page';
import ContentPageStyled from '@glowforge/gf-styled/src/components/content-page.styled';
import { getPage, getJobs } from '../../api/contentful';
import { pagePropType } from '../../prop-types/contentful';
import CustomPageMetadata from '../../components/custom-page-metadata';
import JobsList from '../../components/jobs/jobs-list';
import Canonical from '../../util/canonical'

// TODO: Replace with dynamic importer
import '@glowforge/gf-styled/src/initializers/contentful-page';

const JobsPage = ({ page, jobs, className }) => {
  const customSections = {
    'jobs-page-postings': {
      component: JobsList,
      props: {
        jobs,
      },
    },
  };

  return (
    <>
      <Canonical path='jobs'/>
      <CustomPageMetadata page={page} />
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <ContentPageStyled>
        <Page 
          className={`contentPage JobsHomePage ${className}`}
          {...page.fields} customSections={customSections}
        />
      </ContentPageStyled>
    </>
  );
};

export const getServerSideProps = async () => {
  const [
    page,
    jobs,
  ] = await Promise.all([
    getPage('jobs-home-page'),
    getJobs(),
  ]);
  return {
    props: { page, jobs }
  };
};

JobsPage.propTypes = {
  page: pagePropType.isRequired,
  jobs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  className: PropTypes.string.isRequired
};

/**
 *  Note, until we can get rid of the LESS import at the top, we have to use 
 *  !important to override. Getting rid of the less at the top requires going 
 *  from ui-common to gf-styled and to make sure that the underlying components
 *  (in the library) use styled-components instead.
 */
export default styled(JobsPage)`
  // Below makes the new hero banner better match the old style
  .JobHeroBanner-wrapper > .gf_styled__GridContainer__full {
    max-height: 50vh;
  }
  .perks-list {
    .Sections {
      h2.h2 {
        font-size: 1.0625rem;
        font-family: 'Exo 2', sans-serif;
        letter-spacing: -0.08px;
        line-height: 1.5;
        font-weight: 600;

        margin: 0 !important;
        text-align: left !important;
        text-transform: uppercase;
      }

      .markdown {
        font-size: 1.0625rem;
        font-family: 'Exo 2', sans-serif;
        letter-spacing: -0.08px;
        line-height: 1.5;

        margin-top: 0  !important;
      }

      > * {
        position: relative  !important;
        flex: 1 1 25% !important;

        @media (max-width: 960px) and (min-width: 770px) {
          flex: 1 0 33%  !important;
        }

        @media (max-width: 770px) {
          flex: 1 0 100%  !important;
        }

        &::before {
          content: '__';
          position: absolute;
          font-size: 2rem;
          color: #009fb0;
          font-weight: bold;
          top: -25px;
          line-height: 0;
        }
      }
    }
  }
`;
